import { AddressReference, PlaceDetails } from '@hcs/types';
import { PlaceType } from '@hcs/types';
import { isNumericStr } from '@hcs/utils';

import { PLACES_TYPES_DEFAULT } from '../constants';
import { PlacesSearchResult } from '../types/places-search.types';

export const getPlaceTypeInputForSearch = (
  term: string,
  includePlaceTypes: PlaceType[] = PLACES_TYPES_DEFAULT,
) => {
  return includePlaceTypes.includes(PlaceType.Regions) &&
    includePlaceTypes.includes(PlaceType.Cities)
    ? isNumericStr(term)
      ? PlaceType.Regions
      : PlaceType.Cities
    : includePlaceTypes.includes(PlaceType.Regions)
      ? PlaceType.Regions
      : PlaceType.Cities;
};

export const isPlaceResult = (
  result: PlacesSearchResult | null,
): result is PlaceDetails => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return !!(result as PlaceDetails)?.placeId;
};
export const isAddressResult = (
  result: PlacesSearchResult | null,
): result is AddressReference => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return !!(result as AddressReference)?.hcAddressId;
};
